import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  useSelect,
  Select,
} from "@pankod/refine-antd";
import { useGetIdentity } from "@pankod/refine-core";
import { useUserContext } from "context/user";
import { createUserHistory } from "gql/mutations";
import { ICompetencyType } from "interfaces";


type CreateCompetencyProps = {
  modalProps: ModalProps;
  formProps: FormProps;
};


export const CreateCompetency: React.FC<CreateCompetencyProps> = ({
  modalProps,
  formProps,
}) => {
  const { data: user } = useGetIdentity();
  const { selectProps: competencyTypeSelectProps } = useSelect<ICompetencyType>({
    resource: "competency_types",
    fetchSize: 100,
    optionLabel: "name",
    optionValue: "id",
    metaData: {
      fields: ["id", "name"],
    },
    sort: [{ field: "name", order: "asc", },],
    onSearch: (value) => [
      {
        field: "name",
        operator: "contains",
        value: `${value.toLowerCase()}%`,
      },
    ],
  });
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        created_by: user?.id

      })
    )
  }
  return (
    <Modal {...modalProps} title="Create Competency">
      <Form {...formProps} size="large" layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('competencies', 'create', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        {/* <Form.Item 
          label="Id"
          name="competency_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input/>
        </Form.Item> */}
        <Form.Item
          label="Competency Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Competency Type"
          name="competency_type_id"
          rules={[{ required: true, }]}
        >
          <Select {...competencyTypeSelectProps} />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
